// extracted by mini-css-extract-plugin
export default {"mainDiv":"LoginSignUp_mainDiv__fm34x","textOops":"LoginSignUp_textOops__4UI6k","textSignUp":"LoginSignUp_textSignUp__BWH9E","form":"LoginSignUp_form__p4Crf"};